import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../../api";
import {
  Button,
  ButtonGroup,
  Card,
  CardBody,
  CardFooter,
  H4,
} from "@datapay-by-datacom/design-system";
import { useNavigate, useParams } from "react-router";

interface ThreadDeleteProps {
  workspaceId: string;
  threadId: string;
  onClose: () => void;
}

export function ThreadDelete({
  workspaceId,
  threadId,
  onClose,
}: ThreadDeleteProps) {
  const queryClient = useQueryClient();
  const queryKey = ["workspace", workspaceId, "thread"];
  const _params = useParams();
  const navigate = useNavigate();

  const mutation = useMutation({
    mutationKey: ["workspace", workspaceId, "thread", threadId, "delete"],
    mutationFn: async () => {
      await api.deleteThread(workspaceId, threadId);
      queryClient.invalidateQueries({
        queryKey,
      });
      onClose();
      navigate("/");
    },
  });

  return (
    <Card>
      <CardBody>
        <H4>Delete thread?</H4>
      </CardBody>
      <CardFooter>
        <ButtonGroup>
          <Button variant="secondary" onPress={onClose}>
            Cancel
          </Button>
          <Button
            onPress={() => {
              mutation.mutate();
            }}
          >
            Delete
          </Button>
        </ButtonGroup>
      </CardFooter>
    </Card>
  );
}
